"use client";

import { Reveal, EngravedLine } from "./motion-primitives";

const ITEMS = [
  "Promotional Products",
  "Business Gifts",
  "Employee Recognition",
  "Events",
  "Personalized Projects",
  "Custom Engraving",
];

export function AudienceStrip() {
  return (
    <section className="relative overflow-hidden border-y border-softwhite/10 bg-ink py-8">
      <div className="flex w-max animate-[strip_38s_linear_infinite] gap-12 motion-reduce:animate-none">
        {[0, 1].map((dup) => (
          <ul key={dup} className="flex shrink-0 items-center gap-12" aria-hidden={dup === 1}>
            {ITEMS.map((item) => (
              <li
                key={item}
                className="flex items-center gap-12 font-display text-lg font-semibold whitespace-nowrap text-softwhite/70"
              >
                {item}
                <span className="size-1.5 rotate-45 bg-brass" />
              </li>
            ))}
          </ul>
        ))}
      </div>

      <style>{`@keyframes strip { from { transform: translateX(0); } to { transform: translateX(-50%); } }`}</style>

      <div className="mx-auto mt-10 max-w-[1400px] px-5">
        <EngravedLine className="mb-10" />
        <Reveal>
          <p className="max-w-4xl font-display text-[clamp(1.5rem,3.4vw,2.75rem)] leading-[1.1] font-semibold text-softwhite">
            Engraving for the moments—and businesses—that deserve to be remembered.
          </p>
        </Reveal>
      </div>
    </section>
  );
}